'use client';

import { AdminErrorPage } from '../components/AdminErrorPage';

export default function Error() {
  return (
    <AdminErrorPage
      statusCode="500"
      title="Admin Action Failed"
      message="The admin app could not complete this request. Please go back and try again."
    />
  );
}
